import React from 'react'

const SOURCE_LABELS = {
  'Google News': 'Google',
  'AP': 'AP',
  'Reddit': 'Reddit',
  'google_news': 'Google',
  'ap': 'AP',
  'reddit': 'Reddit',
  'podcast': 'Podcast',
}

function formatSource(name) {
  return SOURCE_LABELS[name] || name
}

export default function CoverageBadge({ score, matches, size = 'md' }) {
  if (!matches || matches.length === 0) return null

  const sourceNames = matches.map(formatSource).join(', ')
  const textSize = size === 'sm' ? 'text-[9px]' : 'text-[10px]'
  const padding = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-0.5'

  const color = matches.length >= 2
    ? 'text-emerald-400 bg-emerald-500/10 border-emerald-500/20'
    : 'text-gray-400 bg-white/5 border-white/10'

  return (
    <span className={`inline-flex items-center gap-1 ${textSize} font-medium ${padding} rounded border ${color}`}>
      Also in: {sourceNames}
    </span>
  )
}
